import { useTranslation } from "react-i18next";

import {
  getPathShortTitle,
  getWeekNumber,
} from "@/domains/certifications/utils";
import ReviewModalBody from "@/features/certifications/knowledge-check-flags/components/ReviewModalBody";
import { ReviewModalProps } from "@/features/certifications/knowledge-check-flags/types";

const ReviewModal = ({ attempt, participant, ...props }: ReviewModalProps) => {
  const { t } = useTranslation();
  if (!attempt) {
    return null;
  }

  const name = attempt.user.fullName || attempt.user.email;
  const week = getWeekNumber(props.certification.modules, attempt.module.id);
  const subtitle = [
    participant &&
      getPathShortTitle(t, props.certification, participant.selectedTrack),
    week === null
      ? attempt.module.title
      : t("certification.admin.knowledgeCheckFlags.weekCheck", { week }),
  ]
    .filter(Boolean)
    .join(" · ");

  return (
    <ReviewModalBody
      key={attempt.id}
      attempt={attempt}
      name={name}
      subtitle={subtitle}
      {...props}
    />
  );
};

export default ReviewModal;
